import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { LOCATION_CONTROLER_URL } from "api/Service";

// Every location for the tenant, disabled ones included — the settings table
// needs to show (and let an admin re-enable) a disabled location, unlike the
// booking form which only ever offers active ones (see useActiveLocations).
export const useLocationsAll = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["locationsAll", tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}${LOCATION_CONTROLER_URL}`
      );

      return response.data;
    },
    enabled: !!tenantVal,
  });
};
